<template>
  <div class="container">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col-md-6 col-lg-4">
        <div class="card shadow-sm">
          <div class="card-body p-5">
            <h4 class="text-center mb-4">Recupera password</h4>
            <form @submit.prevent="handleResetPassword">
              <div class="form-floating mb-3">
                <input 
                  type="email" 
                  class="form-control" 
                  id="email" 
                  v-model="email"
                  placeholder="nome@esempio.com"
                  required
                >
                <label for="email">Email</label>
              </div>

              <div class="form-floating mb-3">
                <input :type="showPassword ? 'text' : 'password'" v-model="newPassword" class="form-control" id="newPassword">
                <label for="newPassword">Nuova password</label>
                <button 
                  type="button" 
                  class="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none"
                  style="z-index: 5"
                  @click="togglePassword"
                >
                  <i class="bi" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </button>
              </div>

              <div class="form-floating mb-3">
                <input :type="showPasswordConfirm ? 'text' : 'password'" v-model="newPasswordConfirm" class="form-control" id="newPasswordConfirm">
                <label for="newPasswordConfirm">Conferma nuova password</label>
                <button 
                  type="button" 
                  class="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none"
                  style="z-index: 5"
                  @click="togglePasswordConfirm"
                >
                  <i class="bi" :class="showPasswordConfirm ? 'bi-eye-slash' : 'bi-eye'"></i>
                </button>
              </div>

              <div v-if="error" class="alert alert-danger py-2 mb-3">
                {{error}}
              </div>

              <div v-if="success" class="alert alert-success py-2 mb-3">
                {{ success }}
              </div>

              <div class="mt-3" v-if="success">
                <button type="button"  class="btn btn-primary w-100"  @click="goToLogin">
                  Torna al login
                </button>
              </div>

              <button v-if="!success"
                type="submit" 
                class="btn btn-primary w-100 py-2"
                :disabled="isLoading"
              >
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                {{ isLoading ? 'Aggiornamento in corso...' : 'Aggiorna la password' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'ResetPasswordView',
  emits: ['change-view'],
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    this.email = urlParams.get('email')
  },
  setup(props, { emit }) {
    const email = ref('')
    const newPassword = ref('')
    const newPasswordConfirm = ref('')
    const isLoading = ref(false)
    const error = ref('')
    const errors = ref({})
    const success = ref('')
    const showPassword = ref(false)
    const showPasswordConfirm = ref(false)

    const togglePassword = () => {
      showPassword.value = !showPassword.value
    }

    const togglePasswordConfirm = () => {
      showPasswordConfirm.value = !showPasswordConfirm.value
    }

    function cleanUrl(url) {
      try {
        const baseUrl = new URL(url);
        const pathname = baseUrl.pathname;

        // Rimuove tutto dopo /reset-password inclusivo
        const resetIndex = pathname.indexOf('/reset-password');
        if (resetIndex !== -1) {
          baseUrl.pathname = pathname.substring(0, resetIndex);
          baseUrl.search = ''; // Rimuove i parametri della query
        }

        return baseUrl.origin + baseUrl.pathname;
      } catch (e) {
        console.error('URL non valido:', e);
        return url; // In caso di errore, ritorna l'URL originale
      }
    }

    const goToLogin = () => {
      const cleanedUrl = cleanUrl(window.location.href)
      window.location.href = cleanedUrl
      emit('change-view', 'LoginView')
    }

    return {
      email,
      isLoading,
      error,
      success,
      showPassword,
      showPasswordConfirm,
      newPassword,
      newPasswordConfirm,
      togglePassword,
      togglePasswordConfirm,
      goToLogin
    }
  },
  methods: {
    async handleResetPassword() {
      try {
        this.isLoading = true
        this.error = ''
        this.success = ''

        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get('token')
        const response = await this.$root.$api.post('/auth/reset-password', { email: this.email, token, password: this.newPassword, password_confirmation: this.newPasswordConfirm })
        this.success = response.data.message
      } catch (err) {
        this.error = err.response?.data?.message
        this.errors = err.response?.data?.errors
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label {
  opacity: .65;
  transform: scale(.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-control:focus {
  box-shadow: 0 0 0 0.25rem rgba(13,110,253,.15);
}

.btn-link {
  color: #6c757d;
}

.btn-link:hover {
  color: #0d6efd;
}
</style>